<template>
  <div class="mainPage">
    <div class="mainBox">
      <div class="aiLeft imgStyle">
        <div class="leftFirst">
          <div class="img img2">
            <img
              class="image"
              v-if="leftPictureList.length > 0"
              :src="leftPictureList[0]"
            />
            <div class="box"></div>
          </div>
          <div class="img img3">
            <img
              class="image"
              v-if="leftPictureList.length > 1"
              :src="leftPictureList[1]"
            />
          </div>
          <div class="img img1">
            <img
              class="image"
              v-if="leftPictureList.length > 2"
              :src="leftPictureList[2]"
            />
          </div>
        </div>
        <div class="leftSec">
          <div class="img img1">
            <img
              class="image"
              v-if="leftPictureList.length > 3"
              :src="leftPictureList[3]"
            />
          </div>
          <div class="img img3">
            <img
              class="image"
              v-if="leftPictureList.length > 4"
              :src="leftPictureList[4]"
            />
          </div>
          <div class="img img2">
            <img
              class="image"
              v-if="leftPictureList.length > 5"
              :src="leftPictureList[5]"
            />
          </div>
        </div>
      </div>
      <div class="aiCenter">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
      <div class="aiRight imgStyle">
        <div class="rightFirst">
          <div class="img img2">
            <img
              class="image"
              v-if="rightPictureList.length > 0"
              :src="rightPictureList[0]"
            />
          </div>
          <div class="img img3">
            <img
              class="image"
              v-if="rightPictureList.length > 1"
              :src="rightPictureList[1]"
            />
          </div>
          <div class="img img1">
            <img
              class="image"
              v-if="rightPictureList.length > 2"
              :src="rightPictureList[2]"
            />
          </div>
        </div>
        <div>
          <div class="img img1">
            <img
              class="image"
              v-if="rightPictureList.length > 3"
              :src="rightPictureList[3]"
            />
          </div>
          <div class="img img2">
            <img
              class="image"
              v-if="rightPictureList.length > 4"
              :src="rightPictureList[4]"
            />
          </div>
          <div class="img img3">
            <img
              class="image"
              v-if="rightPictureList.length > 5"
              :src="rightPictureList[5]"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- -->
    <tabbar
      v-show="
        token &&
          (showTabbar ||
            routerName == 'home' ||
            routerName == 'myCenter' ||
            (showTabbar && routerName == 'chat'))
      "
    ></tabbar>
  </div>
</template>

<script>
import Vue from "vue";
import { Button } from "vant";
import { Slider } from "vant";
import { Swipe, SwipeItem } from "vant";
import { NavBar } from "vant";

import { Form } from "vant";
import { Field } from "vant";
import { Checkbox } from "vant";
import { Toast } from "vant";
import { Popup } from "vant";
import { Cell, CellGroup } from "vant";
import { Switch } from "vant";
import { Loading } from "vant";

Vue.use(Loading);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Checkbox);
Vue.use(Form);
Vue.use(Field);
Vue.use(NavBar);

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Slider);
Vue.use(Button);
import tabbar from "../../components/tabbar/index.vue";
import { pcBackground } from "@/http/home";
export default {
  components: {
    tabbar
  },
  data() {
    return {
      routerName: this.$route.name,
      showTabbar: false,
      token: undefined,
      leftPictureList: [],
      rightPictureList: []
    };
  },
  watch: {
    $route(to, from) {
      Toast.clear();
      this.token = localStorage.getItem("token")
        ? localStorage.getItem("token")
        : null;
      this.routerName = to.name;
      if (window.innerWidth > 1439) {
        this.showTabbar = true;
      }
    }
  },
  mounted() {
    this.token = localStorage.getItem("token")
      ? localStorage.getItem("token")
      : null;
    if (window.innerWidth > 1439) {
      this.showTabbar = true;
      this.getImage();
    }
  },
  methods: {
    getData() {},
    getImage() {
      pcBackground().then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          if (data.list && data.list.length > 0) {
            let left = data.list[0].leftPictureList;
            if (left && left.length > 0) {
              this.leftPictureList = data.list[0].leftPictureList;
            }
            let right = data.list[0].rightPictureList;
            if (right && right.length > 0) {
              this.rightPictureList = data.list[0].rightPictureList;
            }
          }
        }
      });
    }
  }
};
</script>
<style src="@/assets/css/pc.css" scoped></style>
<style>
/* @media screen and (max-width: 1439px) {
  .mainBox .aiLeft,
  .mainBox .aiRight {
    display: none;
  }
  .mainPage {
    width: 750px;
    margin: 0 auto;
    height: 100%;
  }
  .mainBox,
  .mainBox .aiCenter {
    height: 100%;
  }
  .footer .van-tabbar {
    width: 750px;
    margin: 0 auto;
  }
} */

@media screen and (max-width: 1439px) {
  .mainPage,
  .mainBox,
  .aiCenter {
    width: 100%;
    height: 100%;
    /* background-color: #d8eab6; */
  }
  .footer .van-tabbar {
    width: 100%;
  }
}
.aiCenter {
  position: relative;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/main/index.vue